module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M8 14v-4c0-3.308 2.692-6 6-6a6.01 6.01 0 0 1 5.67 4.04C20.034 9.082 20.894 10 22 10s2.022-.902 1.802-1.984C22.882 3.442 18.844 0 14 0 8.476 0 4 4.476 4 10v4H2c-1.106 0-2 1.094-2 2.2V30c0 1.106.894 2 2 2h24c1.106 0 2-.894 2-2V16.2c0-1.106-.894-2.2-2-2.2H8z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/unlock-3.js
// module id = 1466
// module chunks = 14